import { useContext, useState } from "react";
import styles from "./Register.module.scss";
import { context } from "../../../context/context";
import RegisterNum from "./RegisterNum";
import RegisterMail from "./RegisterMail";
import FinallyRegister from "./FinallyRegister";
//
export default function Register() {
  const [swapButton, setSwapButton] = useState("with-mobile");
  const registerCTX = useContext(context);
  const { registerAccSteps, setRegisterAccSteps } = registerCTX;

  if (registerAccSteps.showVerifyCode) {
    return <FinallyRegister />;
  }
  return (
    <>
      <div className={styles.container}>
        <div className={`font_color_change_to_green ${styles.register_title}`}>
          ایجاد حساب کاربری
        </div>
        <div className={styles.login_buttons}>
          <div
            className={`font_color_white ${styles.with_email}`}
            onClick={() => setSwapButton("with-email")}
          >
            ایمیل
          </div>
          <div
            className={`font_color_white ${styles.with_mobile}`}
            onClick={() => setSwapButton("with-mobile")}
          >
            موبایل
          </div>
        </div>
        <div className={styles.lines_under_button}>
          <div
            className={`${styles.line_button} ${
              swapButton === "with-email" ? styles.line_button_active : ""
            }`}
          ></div>
          <div className={styles.line_button}></div>
          <div
            className={`${styles.line_button} ${
              swapButton === "with-mobile" ? styles.line_button_active : ""
            }`}
          ></div>
        </div>
        <main>
          {swapButton === "with-mobile" ? <RegisterNum /> : <RegisterMail />}
        </main>
      </div>
    </>
  );
}
